export default __webpack_public_path__ + "static/media/catpunk-12.e70bd84b.png";